import React from 'react'
import { createRoot } from 'react-dom/client'
import DashboardLayout from './components/DashboardLayout'

const coursenum = window.location.pathname.split('/')[3]

export let startApp = (studentCount, dateRangeText) => {
  const root = createRoot(document.getElementById('react-app'))
  root.render(
    <DashboardLayout
      coursenum={coursenum}
      studentCount={studentCount}
      dateRangeText={dateRangeText}
    />
  )
}
